import React, { useCallback, useState } from 'react';
import DashboardTrainingsList from '../charts/DashboardTrainingsList';

export default function TrainingsCard({ player, loading: profileLoading, gridColSpan = 6 }) {
  const stackTrainings = Number(gridColSpan) < 5;
  const [showBasics, setShowBasics] = useState(true);
  const [showSpec, setShowSpec] = useState(true);

  const toggleBasics = useCallback(() => {
    setShowBasics((prev) => !prev);
  }, []);

  const toggleSpec = useCallback(() => {
    setShowSpec((prev) => !prev);
  }, []);

  const filterToolbar = (
    <div className="member-dashboard__trainings-toolbar">
      <button
        type="button"
        className={
          'member-dashboard__trainings-filter-btn' +
          (showBasics ? ' member-dashboard__trainings-filter-btn--active' : '')
        }
        aria-pressed={showBasics}
        aria-label={showBasics ? 'Hide basic trainings' : 'Show basic trainings'}
        onClick={toggleBasics}
      >
        Basics
      </button>
      <button
        type="button"
        className={
          'member-dashboard__trainings-filter-btn' +
          (showSpec ? ' member-dashboard__trainings-filter-btn--active' : '')
        }
        aria-pressed={showSpec}
        aria-label={showSpec ? 'Hide specializations' : 'Show specializations'}
        onClick={toggleSpec}
      >
        Spec
      </button>
    </div>
  );

  if (profileLoading && !player) {
    return (
      <section
        className={
          'member-dashboard__panel-card member-dashboard__trainings-card' +
          (stackTrainings ? ' member-dashboard__trainings-card--stacked' : '')
        }
        aria-busy="true"
        aria-label="Trainings"
        data-resource="private.navbar.personalhub.trainings"
        data-action="read"
        data-description="Personal hub — trainings"
      >
        <div className="member-dashboard__panel-card-head member-dashboard__trainings-card-head">
          <h2 className="member-dashboard__panel-title">Trainings</h2>
          {filterToolbar}
        </div>
        <div className="member-dashboard__panel-card-body">
          <p className="member-dashboard__panel-placeholder">Loading…</p>
        </div>
      </section>
    );
  }

  if (!player) return null;

  return (
    <section
      className={
        'member-dashboard__panel-card member-dashboard__trainings-card' +
        (stackTrainings ? ' member-dashboard__trainings-card--stacked' : '')
      }
      aria-label="Trainings"
      data-resource="private.navbar.personalhub.trainings"
      data-action="read"
      data-description="Personal hub — trainings"
    >
      <div className="member-dashboard__panel-card-head member-dashboard__trainings-card-head">
        <h2 className="member-dashboard__panel-title">Trainings</h2>
        {filterToolbar}
      </div>
      <div className="member-dashboard__panel-card-body">
        <DashboardTrainingsList
          player={player}
          showBasics={showBasics}
          showSpec={showSpec}
        />
      </div>
    </section>
  );
}
